import Vue from 'vue'
import MapApp from './components/MapApp.vue'
Vue.config.productionTip = false


new Vue({
    el: '#c-whats-on-by-map-app',
    components: {
        MapApp
    }
})
